import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import ErrorBoundary from "./components/ErrorBoundary";
// Add your imports here
import AuthenticationAccountConnection from "./pages/authentication-account-connection";
import DashboardSyncOverview from "./pages/dashboard-sync-overview";
import PlaylistSelectionSyncSetup from "./pages/playlist-selection-sync-setup";
import SyncPreviewConfiguration from "./pages/sync-preview-configuration";
import SyncProgressRealTimeTracking from "./pages/sync-progress-real-time-tracking";
import SyncResultsManagement from "./pages/sync-results-management";
import NotFound from "./pages/NotFound";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsAndConditions from "./pages/TermsAndConditions";
import Header from "./components/ui/Header";
import Footer from "./components/ui/Footer";
import ViewGuide from './pages/authentication-account-connection/ViewGuide';
import ContactSupport from './pages/authentication-account-connection/ContactSupport';
import Login from './pages/authentication-account-connection/Login';
import Signup from './pages/authentication-account-connection/Signup';
import ProtectedRoute from './components/ProtectedRoute';
import AuthenticatedRoute from './components/AuthenticatedRoute';
import Pricing from './pages/Pricing';
import ProfileSettings from './pages/ProfileSettings';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
          <ScrollToTop />
          <Header/>
          <RouterRoutes>
            {/* <Route path="/" element={<DashboardSyncOverview />} /> */}
            <Route path="/" element={<AuthenticationAccountConnection />} />
            <Route path="/authentication-account-connection" element={<AuthenticationAccountConnection />} />
            <Route path="/dashboard-sync-overview" element={<DashboardSyncOverview />} />
            <Route path="/playlist-selection-sync-setup" element={<PlaylistSelectionSyncSetup />} />
            <Route path="/sync-preview-configuration" element={<SyncPreviewConfiguration />} />
            <Route path="/sync-progress-real-time-tracking" element={<SyncProgressRealTimeTracking />} />
            <Route path="/sync-results-management" element={<SyncResultsManagement />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
            <Route path="/view-guide" element={<ViewGuide />} />
            <Route path="/contact-support" element={<ContactSupport />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/profile-settings" element={
              <AuthenticatedRoute>
                <ProfileSettings />
              </AuthenticatedRoute>
            } />
            <Route path="/login" element={
              <ProtectedRoute>
                <Login />
              </ProtectedRoute>
            } />
            <Route path="/signup" element={
              <ProtectedRoute>
                <Signup />
              </ProtectedRoute>
            } />
            <Route path="*" element={<NotFound />} />
          </RouterRoutes>
          <Footer/>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;